const { initializeInteractiveGarage } = require(
    'public/templates/modules/interactive_garage/interactive-garage-vendor'
);

const applyListItemSelectorOverride = function (isProductPage, rp$) {
    if (isProductPage || typeof igViewOnVehicleSettings === 'undefined') {
        return false;
    }

    igViewOnVehicleSettings.listItemSelector = rp$('.catalog-product-card').length > 0
        ? '.catalog-product-card'
        : '.catalog-product';

    return true;
};

const clearSettingsWaitInterval = function (settingsWaitState) {
    if (settingsWaitState.intervalId !== null) {
        clearInterval(settingsWaitState.intervalId);
        settingsWaitState.intervalId = null;
    }
};

const initializeWithSettingsWait = function (
    targetViewType,
    isProductPage,
    rp$,
    settingsWaitState
) {
    clearSettingsWaitInterval(settingsWaitState);

    if (targetViewType !== 'list') {
        initializeInteractiveGarage(rp$, targetViewType);
        return;
    }

    if (applyListItemSelectorOverride(isProductPage, rp$)) {
        initializeInteractiveGarage(rp$, targetViewType);
        return;
    }

    const maxAttempts = 50; // 5 seconds
    const interval = 100; // 100ms
    let attempts = 0;
    settingsWaitState.intervalId = setInterval(function () {
        attempts += 1;

        if (applyListItemSelectorOverride(isProductPage, rp$) || attempts >= maxAttempts) {
            clearSettingsWaitInterval(settingsWaitState);
            initializeInteractiveGarage(rp$, targetViewType);
        }
    }, interval);
};

const handleSearchResultsResponse = function (rp$, isProductPage, settingsWaitState) {
    setTimeout(function () {
        initializeWithSettingsWait('list', isProductPage, rp$, settingsWaitState);
    }, 1);
};

const removeBodyOverlaySpinner = function (rp$) {
    const bodyOverlaySpinner = rp$('body').overlaySpinner;
    if (bodyOverlaySpinner !== undefined && typeof bodyOverlaySpinner.remove === 'function') {
        bodyOverlaySpinner.remove();
    }
};

const isReactProductMediaPage = function (rp$, isProductPage) {
    return isProductPage && rp$('[data-react-island="product_media"]').length > 0;
};

const initializeOnReady = function (rp$, pageIds) {
    const pageId = rp$('.main').attr('id');
    const isProductPage = pageId === pageIds.PRODUCT;
    const viewType = isProductPage ? 'product' : 'list';
    const settingsWaitState = { intervalId: null };

    // product_media React island owns PDP IG binding via rebindProductInteractiveGarage.
    if (!isReactProductMediaPage(rp$, isProductPage)) {
        initializeWithSettingsWait(viewType, isProductPage, rp$, settingsWaitState);
    }

    rp$(document).off('searchResults:response.interactive_garage').on('searchResults:response.interactive_garage', function () {
        handleSearchResultsResponse(rp$, isProductPage, settingsWaitState);
    });

    rp$(document)
        .off('shown.bs.modal.interactive_garage', '#ig_modal')
        .on('shown.bs.modal.interactive_garage', '#ig_modal', function () {
            removeBodyOverlaySpinner(rp$);
        });
};

const THE_SCRIPT = function () {
    const $onReady = require('public/js/lib/on-ready');
    const { PAGE_IDS } = require('public/js/constants/pages');

    $onReady({
        rp$, window,
        label: 'interactive_garage',
        fn: function () {
            initializeOnReady(rp$, PAGE_IDS);
        }
    });
};

try {
    // Because __CURRENT_SCRIPT__ is injected by plugin Client, we need this here to try and pass it up to the plugin code
    if (typeof __CURRENT_SCRIPT__ === 'undefined') {
        throw new Error('__CURRENT_SCRIPT__ is not defined');
    }
    __CURRENT_SCRIPT__ = THE_SCRIPT;
} catch (e) {
    THE_SCRIPT();
}